import Nav from "./../Page/Share/Nav/Nav";
const Post23 = () => {
  return (
    <div>
      <div className="container">
        <Nav></Nav>

        <div className="infowork">
          {/* items Title} */}
          <h2>
            Perspective Brand Guidelines
          </h2>
          {/* items?.Description */}
          <p>

          </p>
          {/* img section */}
          <img src="https://i.ibb.co/n3X1kJ1/Brand-Guidelines-01.jpg" alt="" />
          <img src="https://i.ibb.co/Nj6V1sq/Brand-Guidelines-02.jpg" alt="" />
          <img src="https://i.ibb.co/JmwNYjx/Brand-Guidelines-03.jpg" alt="" />
          <img src="https://i.ibb.co/xS66dZB/Brand-Guidelines-04.jpg" alt="" />
          <img src="https://i.ibb.co/48c4BYN/Brand-Guidelines-05.jpg" alt="" />
          <img src="https://i.ibb.co/wcMDfhS/Brand-Guidelines-06.jpg" alt="" />
          <img src="https://i.ibb.co/MNwM8NB/Brand-Guidelines-07.jpg" alt="" />
          <img src="https://i.ibb.co/CM1d0N2/Brand-Guidelines-08.jpg" alt="" />
          <img src="https://i.ibb.co/XsbpLk7/Brand-Guidelines-09.jpg" alt="" />
          <img src="https://i.ibb.co/S69p3M3/Brand-Guidelines-10.jpg" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <p>

          </p>
        </div>
      </div>
    </div>
  );
};

export default Post23;
